export default [
  {
    path: '/sejours',
    name: 'stayList',
    component: () => import('@/views/Stay/List.vue'),
    meta: { layout: 'content' }
  },
  {
    path: '/sejours/sessions/:runId',
    name: 'staySessionDetails',
    component: () => import('@/views/Stay/Details.vue'),
    meta: { layout: 'content' }
  }
]
